import PropTypes from "prop-types";
import {checkJsonExist, checkJsonProp} from "./";

export const arraySearch = function (array, keys, value) {
    let searchedArray = [];

    if (!array || !keys || !value) {
        return [];
    }

    array.filter(item =>
        keys.map(key =>
            checkJsonExist(item, key) ? checkJsonProp(item, key).toLocaleLowerCase().includes(value.toLocaleLowerCase()) ? searchedArray.push(item) : null : null
        )
    );

    return searchedArray;
};

arraySearch.propTypes = {
    array: PropTypes.array.isRequired,
    keys: PropTypes.array.isRequired,
    value: PropTypes.string.isRequired
};